// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__Swj0z","authInner":"Auth_authInner__ptDBK","form":"Auth_form__lMLI+","label":"Auth_label__WjnpR","input":"Auth_input__XWIzH","submit":"Auth_submit__vJwwE"};